import * as jalaliMoment from "jalali-moment";
declare global {
  interface String {
    FaToEnDigits(): string;
  }
  interface Date {
    EndOfDay(): Date;
  }
}
String.prototype.FaToEnDigits = function(): string {
  return String(this).toString().replace('۰','0')
                                .replace('۱','1')
                                .replace('۲','2')
                                .replace('۳','3')
                                .replace('۴','4')
                                .replace('۵','5')
                                .replace('۶','6')
                                .replace('۷','7')
                                .replace('۸','8')
                                .replace('۹','9') ;
}

Date.prototype.EndOfDay=function():Date{
  return this;
}
export {};
